import type { Variants } from 'framer-motion'

export const fadeInUp: Variants = {
  initial: { opacity: 0, y: 12 },
  animate: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.4, ease: 'easeOut' },
  },
  exit: { opacity: 0, y: -10, transition: { duration: 0.3 } },
}

export const createHoverLift = (y: number, scale: number): Variants => ({
  initial: { y: 0, scale: 1 },
  hover: {
    y,
    scale,
    transition: { type: 'spring', stiffness: 300, damping: 20 },
  },
})

export const createFloatIn = (y: number): Variants => ({
  initial: { opacity: 0, y },
  animate: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: 'easeOut' },
  },
})

// Additional variants can be added here as the design system evolves.
